import React, { useEffect, useState } from 'react';

import { pastWork, currentWork } from "./project-data.js";
import GalleryV2 from './Gallery_v2';
import { Tabs } from 'antd';
import ProjectModal from "./ProjectModal.js";

export default function GalleryContainer() {
    const [showOneProject, setShowOneProject] = useState(false);
    const [project, setProject] = useState(null);
    const [mobileView, setMobileView] = useState(window.innerWidth <=700);

    useEffect(() => {
        const handleResize = () => setMobileView(window.innerWidth <= 700);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    },[])

    const tabItems = [
        {
            label: 'Currently Available',
            key: 1,
            children: <GalleryV2 projects={currentWork} setProject={setProject} setShowOneProject={setShowOneProject} />
        },
        {
            label: 'Past Work',
            key: 2,
            children: <GalleryV2 projects={pastWork} setProject={setProject} setShowOneProject={setShowOneProject} />
        }
    ]

    return (
        <>
            <Tabs 
                defaultActiveKey={1}
                tabPosition={mobileView ? 'top' : 'left'}
                items={tabItems}
                className={`w-full pt-4 ${mobileView ? 'mobile-tabs' : ''}`}
            />
            {showOneProject ? <ProjectModal project={project} open={showOneProject} setOpen={setShowOneProject} /> : null}
        </>
    )
}